import { Cart } from 'types';
import { i18nStore } from 'contexts/i18n';

// sometimes currency can be "$0.00" which is valid string, hence the regex check
/* regular expression /[^0-9.-]/g is used to match and remove any characters that are not digits (0-9), hyphens (-),
   or periods (.) from the 'currency' string. */
export const convertCurrencyToNumber = (currency = '') =>
  parseFloat(currency.replace(/[^0-9.-]/g, ''));

export const isAllLineItemsPriceValid = (cart: Cart) => {
  if (cart.lineItems.length === 0) {
    return false;
  }

  return cart.lineItems.every(
    item => convertCurrencyToNumber(item.displayTotal) >= 0
  );
};

export const hasBulkDiscount = (discountPercentage?: string): boolean => {
  return (
    !!discountPercentage &&
    discountPercentage !== '0%' &&
    discountPercentage !== '0'
  );
};

export const buildDiscountLabel = (
  discountPercentage: string,
  i18n: i18nStore
): string => {
  if (!discountPercentage || discountPercentage.length === 0) {
    return '';
  }

  return `${discountPercentage} ${i18n['Saved']}`;
};
